import fonts from '../theme/foundations/fonts'

const baseStyle = {
  fontFamily: [fonts.dnvDisplay, fonts.gantari].join(', '),
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '125%',
}

const defaultProps = {
  size: 'lg',
}

const sizes = {
  sm: {
    fontSize: '18px',
  },
  md: {
    fontSize: '20px',
  },
  lg: {
    fontSize: '24px',
  },
  xl: {
    fontSize: '32px',
  },
  '2xl': {
    fontSize: '50px',
  },
}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
